var map = {
	"./1.png": "BaPB",
	"./10.png": "vSPe",
	"./11.png": "929G",
	"./12.png": "A7bo",
	"./13.png": "OP5c",
	"./14.png": "xdo3",
	"./15.png": "Ax0G",
	"./16.png": "Bcek",
	"./17.png": "po9g",
	"./18.png": "wpee",
	"./19.png": "xTmB",
	"./2.png": "2GkV",
	"./20.png": "QeE0",
	"./21.png": "nsHY",
	"./22.png": "dHtA",
	"./23.png": "kIk0",
	"./24.png": "QkIh",
	"./25.png": "FHbf",
	"./26.png": "AP0q",
	"./27.png": "oYvP",
	"./28.png": "UWHC",
	"./29.png": "sSno",
	"./3.png": "HwQ+",
	"./30.png": "lP2W",
	"./31.png": "YsWd",
	"./32.png": "sQv3",
	"./33.png": "Uvj7",
	"./34.png": "5RaX",
	"./35.png": "OC1W",
	"./36.png": "L+IY",
	"./37.png": "W9Rg",
	"./38.png": "UdhG",
	"./39.png": "eXVS",
	"./4.png": "x+fG",
	"./40.png": "WGCT",
	"./5.png": "1t8t",
	"./6.png": "VM1M",
	"./7.png": "mMqC",
	"./8.png": "PTHj",
	"./9.png": "n2xd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5Sui";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word ^\.\/.*\.png$
// module id = 5Sui
// module chunks = 1